/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Select_ScopeInputs */

const en_common_select_scope = /** @type {(inputs: Common_Select_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select scope`)
};

const es_common_select_scope = /** @type {(inputs: Common_Select_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona alcance`)
};

/**
* | output |
* | --- |
* | "Select scope" |
*
* @param {Common_Select_ScopeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_select_scope = /** @type {((inputs?: Common_Select_ScopeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Select_ScopeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_select_scope(inputs)
	return en_common_select_scope(inputs)
});